/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

export const handleErrorMessagesSystemReminder = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_SR,
  errorMessagesInRedux: data,
});

export const dispatchFetchSystemReminderList = (data) => {
  return {
    systemReminderList: data,
    type: actionTypes.GET_SYSTEM_REMINDER_LIST,
  };
};
export const getSystemReminderGridList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SYSTEM_REMINDERS_USER_LIST, value)
    .then((response) => {
      dispatch(
        dispatchFetchSystemReminderList(
          response?.data && response?.data?.sysReminderResponse
        )
      );
    })
    .catch(() => {
      dispatch(dispatchFetchSystemReminderList([]));
      dispatch(
        handleErrorMessagesSystemReminder([
          constantMessageData.FAILED_MESSAGE_GENERIC,
        ])
      );
    });
};

export const clearReduxSystemReminderScreen = () => (dispatch) => {
  dispatch(dispatchFetchSystemReminderList([]));
  dispatch(handleErrorMessagesSystemReminder([]));
};
